module.exports = __webpack_public_path__ + "static/media/privacy.5724231e.svg";